import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Spinner from '../../Components/Spinner/Spinner';
import { ORIGIN } from '../../shared';
import './Redirect.scss';

const TEST_TAKER_RESULT_ID = 'testTakerResultID';
const ERR_MSG = 'errMsg';

function Redirect() :JSX.Element {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!(searchParams.get(TEST_TAKER_RESULT_ID))) {
      navigate('/');
    } else {
      window.parent.postMessage(
        {
          testTakerResultID: searchParams.get(TEST_TAKER_RESULT_ID),
          errMsg: searchParams.get(ERR_MSG)
        },
        {
          targetOrigin: ORIGIN
        }
      );
    }
  }, [navigate, searchParams]);

  return (
    <div className="nqt-redirect-container">
      <Spinner size={90} />
    </div>
  );
}

export default Redirect;